import axios from 'axios';
import Settings from './config';

export default {

    getConfiguration(cb) {
        axios.get('/umbraco/api/restaurant/getConfiguration')
            .then(response => {
                cb(response.data);
            });
    },

    getAvailability(payload, cb) {

        axios.post(Settings.ENDPOINT + 'api/restaurant', payload)
            .then(response => {
                cb(response.data);
            });
    }
}